module.exports = __webpack_public_path__ + "static/img/cang.ea7f704.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/manman/images/cang.jpg
// module id = FInE
// module chunks = 21